import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
/* zod-compiler shared */
var __zcBf_0={};
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

import {PayloadSchema as BasePayloadSchema} from '../../lib/types/payload'
import {DATA_MARQUEE_EVENT_LIMIT, FOOTER_REPOSITORY_LIMIT} from './utils/config'

export const HomepageEventSchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  type: z.enum(['pull_request_opened', 'pull_request_merged', 'repository_forked', 'repository_starred', 'push']),
  actorLogin: z.string(),
  repositoryNameWithOwner: z.string(),
  url: z.string(),
  timestamp: z.string(),
});
function __fc_0(input){return typeof input==="object"&&input!==null&&!Array.isArray(input)&&typeof input["actorLogin"]==="string"&&typeof input["repositoryNameWithOwner"]==="string"&&typeof input["url"]==="string"&&typeof input["timestamp"]==="string"&&(input["type"]==="pull_request_opened"||input["type"]==="pull_request_merged"||input["type"]==="repository_forked"||input["type"]==="repository_starred"||input["type"]==="push");}
function __vb_1(input){var __bv_2,__bv_3,__bv_4,__bv_5,__bv_6,__bo_7;if(typeof input!=="object"||input===null||Array.isArray(input))return __zcBf_0;__bv_2=input["actorLogin"];if(!(typeof __bv_2==="string"))return __zcBf_0;__bv_3=input["repositoryNameWithOwner"];if(!(typeof __bv_3==="string"))return __zcBf_0;__bv_4=input["url"];if(!(typeof __bv_4==="string"))return __zcBf_0;__bv_5=input["timestamp"];if(!(typeof __bv_5==="string"))return __zcBf_0;__bv_6=input["type"];if(!((__bv_6==="pull_request_opened"||__bv_6==="pull_request_merged"||__bv_6==="repository_forked"||__bv_6==="repository_starred"||__bv_6==="push")))return __zcBf_0;__bo_7={"type":__bv_6,"actorLogin":__bv_2,"repositoryNameWithOwner":__bv_3,"url":__bv_4,"timestamp":__bv_5};return __bo_7;}
var __rfm_z=__zs.safeParse;
function safeParse_HomepageEventSchema(input){
var __bd_8=__vb_1(input);
if(__bd_8!==__zcBf_0){return{success:true,data:__bd_8};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_HomepageEventSchema,__zs,null,__fc_0);
})()

export const HomepageRepositorySchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  nameWithOwner: z.string(),
  description: z.string().nullable(),
  url: z.string(),
  newStars: z.number().int(),
});
function __fc_1(input){var __w_0;return typeof input==="object"&&input!==null&&!Array.isArray(input)&&typeof input["nameWithOwner"]==="string"&&typeof input["url"]==="string"&&((__w_0=input["description"])===null||(typeof __w_0==="string"))&&Number.isSafeInteger(input["newStars"]);}
function __vb_2(input){var __bv_3,__bv_4,__bv_5,__bv_6,__bo_7;if(typeof input!=="object"||input===null||Array.isArray(input))return __zcBf_0;__bv_3=input["nameWithOwner"];if(!(typeof __bv_3==="string"))return __zcBf_0;__bv_4=input["url"];if(!(typeof __bv_4==="string"))return __zcBf_0;__bv_5=input["description"];if(!((__bv_5===null||(typeof __bv_5==="string"))))return __zcBf_0;__bv_6=input["newStars"];if(!(Number.isSafeInteger(__bv_6)))return __zcBf_0;__bo_7={"nameWithOwner":__bv_3,"description":__bv_5,"url":__bv_4,"newStars":__bv_6};return __bo_7;}
var __rfm_z=__zs.safeParse;
function safeParse_HomepageRepositorySchema(input){
var __bd_8=__vb_2(input);
if(__bd_8!==__zcBf_0){return{success:true,data:__bd_8};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_HomepageRepositorySchema,__zs,null,__fc_1);
})()

const HomepagePayloadSchema = BasePayloadSchema.extend({
  recentEvents: safeOptional(
    z.array(HomepageEventSchema).transform(events => events.slice(0, DATA_MARQUEE_EVENT_LIMIT)),
  ),
  featuredRepositories: safeOptional(
    z.array(HomepageRepositorySchema).transform(repositories => repositories.slice(0, FOOTER_REPOSITORY_LIMIT)),
  ),
})

export type HomepageEvent = z.infer<typeof HomepageEventSchema>
export type HomepageRepository = z.infer<typeof HomepageRepositorySchema>
export type Payload = z.infer<typeof HomepagePayloadSchema>

export const PayloadSchema = z.unknown().transform((payload, ctx): Payload => {
  const schema = isFeatureEnabled('site_homepage_refresh_2026') ? HomepagePayloadSchema : BasePayloadSchema
  const result = schema.safeParse(payload)

  if (!result.success) {
    for (const issue of result.error.issues) {
      ctx.addIssue({...issue})
    }
    return z.NEVER
  }

  return result.data
})

export function toPayload(payload: unknown): Payload {
  return PayloadSchema.parse(payload)
}

export function isPayload(payload: unknown): payload is Payload {
  return PayloadSchema.safeParse(payload).success
}
